import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Form({
  id,
  csrf,
  className,
  onSubmit,
  children,
  role,
  noValidate,
  ...extraProps
}) {
  return /*#__PURE__*/_jsxs("form", {
    ...extraProps,
    id: id,
    className: className,
    role: role,
    onSubmit: onSubmit,
    noValidate: noValidate,
    children: [csrf && csrf.enabled && /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "_csrf_token",
      value: csrf.token
    }), children]
  });
}